import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EditableCustomField from './EditableCustomField';
import ReadOnlyCustomField from './ReadOnlyCustomField';

export const CustomField = ({
  editable,
  customFieldValue,
  onChange,
  name,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  ...rest
}) => {
  return (
    <label htmlFor={name}>
      {editable ? (
        <EditableCustomField
          customFieldValue={customFieldValue}
          onChange={onChange}
          name={name}
          enableNoChangeOption={enableNoChangeOption}
          enableNoValueOption={enableNoValueOption}
          {...rest}
        />
      ) : (
        <ReadOnlyCustomField customFieldValue={customFieldValue} {...rest} />
      )}
    </label>
  );
};

CustomField.propTypes = {
  editable: PropTypes.bool,
  customFieldValue: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  name: PropTypes.string,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool
};

export default memo(CustomField);
